import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "@/lib/api";
import { toast } from "sonner";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, pw);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl border border-ahm-teal/10 p-10">
        <p className="text-xs uppercase tracking-[0.3em] text-ahm-orange font-semibold mb-3">Admin access</p>
        <h1 className="font-display text-5xl text-ahm-teal leading-tight">Welcome back.</h1>
        <form onSubmit={submit} className="space-y-6 mt-8">
          <label className="block">
            <span className="block text-xs uppercase tracking-[0.25em] text-ahm-teal/70 font-semibold mb-2">Email</span>
            <input
              type="email"
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-ahm-teal/25 focus:border-ahm-orange py-3 text-lg text-ahm-teal outline-none"
              required
            />
          </label>
          <label className="block">
            <span className="block text-xs uppercase tracking-[0.25em] text-ahm-teal/70 font-semibold mb-2">Password</span>
            <input
              type="password"
              data-testid="admin-password-input"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="w-full bg-transparent border-b border-ahm-teal/25 focus:border-ahm-orange py-3 text-lg text-ahm-teal outline-none"
              required
            />
          </label>
          <button type="submit" disabled={busy} className="btn-pill w-full justify-center" data-testid="admin-login-button">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
